

















import { Component, Vue } from 'vue-property-decorator'

import { PAGE_TITLE_ALBUM } from '../../config'
import SwipePreview from '../swipePreview.vue'
import { allowRefreshOrShare, getPosition, getRouterQuery } from '@utils/index'
import { Overlay } from 'vant'

import { namespace } from 'vuex-class'
const shopHomeModule = namespace('shopHome')

@Component({
  components: {
    SwipePreview,
    [Overlay.name]: Overlay,
  },
})
export default class ShopAlbum extends Vue {
  private businessId: any
  private cityId = ''

  @shopHomeModule.State shopDetail!: any
  @shopHomeModule.Action getShopDetailAction!: (par: { businessId: string | number }) => Promise<any>

  photoPreviewShow = false
  photoPreviewItems: any[] = []
  photoPreviewIndex = 0

  get albumData() {
    return this.shopDetail && this.shopDetail.albums || []
  }

  async created() {
    allowRefreshOrShare(false, false)
    this.$setTitle(PAGE_TITLE_ALBUM)
    const businessId = getRouterQuery(this.$route.query.businessId)
    this.businessId = businessId
    const po = await getPosition()
    this.cityId = (po && po.cityId) || '320100'
    const par = {
      businessId: this.businessId,
      latitude: po ? po.lat : '',
      longitude: po && po.lng,
    }
    if (!this.shopDetail) {
      await this.getShopDetailAction(par)
    }
  }

  previewPhoto(items: any[], index: number) {
    this.photoPreviewShow = true
    this.photoPreviewItems = items
    this.photoPreviewIndex = index
  }
}
